export default "__VITE_ASSET__a15101d5__"